export default "__VITE_ASSET__BD$jLFLg__"